import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import TableRow from 'material-ui/Table/TableRow';
import TableRowColumn from 'material-ui/Table/TableRowColumn';
import DeleteDialog from './DeleteDialog';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';

const tableRowColumnDeleteStyle = {
    width: 54,
    paddingRight: 6,
    paddingLeft: 0
};

const tableRowColumnDeleteDialogStyle = {
    width: 0
};

class PackColumn extends Component {
    state = {
        deleteDialogOpen: false
    };

    toggleDeleteDialog = () => this.setState(state => ({ deleteDialogOpen: !state.deleteDialogOpen }));

    render() {
        const { deleteDialogOpen } = this.state;
        const { pack = {}, deletePack, ...otherProps } = this.props;

        const tableProps = { ...otherProps };
        Reflect.deleteProperty(tableProps, 'dispatch');

        return (
            <TableRow {...tableProps}>
                <TableRowColumn>
                    <Link to={`/admin/packs/${pack.id}`}>{pack.name}</Link>
                </TableRowColumn>
                <TableRowColumn style={tableRowColumnDeleteStyle}>
                    <IconButton
                        onClick={() => {
                            this.toggleDeleteDialog();
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </TableRowColumn>
                <TableRowColumn style={tableRowColumnDeleteDialogStyle}>
                    <DeleteDialog
                        isOpen={deleteDialogOpen}
                        deleteId={pack.id}
                        deleteName={pack.name}
                        deletePack={deletePack}
                        toggleCreateDialog={this.toggleDeleteDialog}
                    />
                </TableRowColumn>
            </TableRow>
        );
    }
}

PackColumn.propTypes = {
    pack: PropTypes.object.isRequired,
    deletePack: PropTypes.func.isRequired
};

export default PackColumn;



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/PackColumn.js
 **/